/* Drop "Kann nicht aus meiner Haut": Video-Loops und mobile Kaufleiste.
   - Videos laden erst, wenn sie sichtbar sind; es spielt immer nur das am besten sichtbare.
   - "Bewegung reduzieren" oder Datensparmodus: keine Videos, nur Poster.
   - Kaufleiste (mobil) erscheint, sobald der Hero aus dem Bild ist. */
(function () {
  if (window.knamhInit) return;
  window.knamhInit = true;

  function initVideos() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var c = navigator.connection;
    var save = c && (c.saveData || /2g/.test(c.effectiveType || ''));
    if (reduce || save || !('IntersectionObserver' in window)) return;
    var vids = Array.prototype.slice.call(document.querySelectorAll('video.knamh-video'));
    if (!vids.length) return;
    var desk = window.matchMedia('(min-width: 750px)');
    var ratios = new Map();

    function eligible(v) {
      var m = v.dataset.media;
      if (!m) return true;
      return m === 'desktop' ? desk.matches : !desk.matches;
    }
    function load(v) {
      if (v.dataset.loaded) return;
      v.dataset.loaded = '1';
      Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (s) {
        s.src = s.dataset.src;
      });
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      v.load();
    }
    function update() {
      var best = null, br = 0;
      vids.forEach(function (v) {
        var r = ratios.get(v) || 0;
        if (eligible(v) && r > br) { br = r; best = v; }
      });
      vids.forEach(function (v) {
        if (v === best && br >= 0.25 && !document.hidden) {
          load(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
      update();
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    vids.forEach(function (v) { io.observe(v); });
    document.addEventListener('visibilitychange', update);
    if (desk.addEventListener) desk.addEventListener('change', update);
  }

  function initSticky() {
    var bar = document.querySelector('[data-knamh-sticky]');
    var hero = document.querySelector('[data-knamh-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('knamh-sticky-on', show);
    }, { threshold: 0 });
    io.observe(hero);
  }

  function init() { initVideos(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
